import Typography from "@mui/material/Typography";
import { Container, Grid, Stack } from "@mui/material";

// libraries
import { useNavigate } from "react-router-dom";

// components
import Button, { ButtonType } from "../../../components/common/button";
import styled from "@emotion/styled";
import { BUTTONS, DESCRIPTION, TITLE } from "./constants";
import { ROUTES } from "../../../setup/constants";

import "./style.css";

const Img = styled("img")({
  margin: "auto",
  display: "block",
  maxWidth: "100%",
  maxHeight: "100%",
});

const ContractNotFound = () => {
  const navigate = useNavigate();

  const onHomeClick = () => {
    navigate(`${ROUTES.HOME}`);
  };
  return (
    <Container maxWidth="sm">
      <div className="not-found">
        <Stack spacing={4} justifyContent="center">
          <Grid item>
            <Img alt="complex" src="/assets/images/svg/notFound.svg" />
          </Grid>
          <div className="not-found-body">
            <Typography gutterBottom variant="h4">
              {TITLE}
            </Typography>
            <Typography variant="body2" gutterBottom>
              {DESCRIPTION}
            </Typography>
          </div>
          <Grid>
            <Button
              fullWidth
              buttonType={ButtonType.OUTLINED}
              size="large"
              onClick={() => onHomeClick()}>
              {BUTTONS.GO_HOME}
            </Button>
          </Grid>
        </Stack>
      </div>
    </Container>
  );
};

export default ContractNotFound;
